import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAutocomplete,{attrs:{"items":_vm.filteredDebrisTypes,"label":_vm.field.text,"placeholder":"Wybierz kod","dense":"","outlined":"","clearable":"","item-value":"code","item-text":_vm.getDebrisString,"filter":_vm.searchDebrisType},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }